export default __webpack_public_path__ + "static/media/avatar2.93104c40.jpg";